module.exports = __webpack_public_path__ + "media/images/lb/434-e33180ea5c1282cb3b8722e25f6c17c5.svg";